// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table {\n    border-spacing: 10px;\n    /*border: 1px solid gray;*/\n}", "",{"version":3,"sources":["webpack://src/UserComponent/UserTable.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,0BAA0B;AAC9B","sourcesContent":["table {\n    border-spacing: 10px;\n    /*border: 1px solid gray;*/\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
